import { Router } from '@angular/router';

export class AppCore {

    constructor() { }

    /**
     * Verifica la existencia del token del usuario
    */
    getToken(): string {
        let token = localStorage.getItem('token');
        try {
            if (token == null) {
                throw new Error('El token no se ha definido.');
            }
            return token;
        } catch (e) {
            console.error(e);
        }
    }


    /**
     * Da formato a los datos para poder enviarse en una peticion http
     * @param parametros Objeto o arreglo con los datos que seran enviados en una peticion de http
     */
    params(parametros: any): string {
        let params: string = 'json=' + JSON.stringify(parametros);
        return params;
    }


    /**
     * Crea una variable llamada "data" en localStorage donde se almacenan cosas de forma persistente,
     * normalmente se utiliza para mejorar la experiencia del usuario
     * @param name Nombre de la variable a incorporar al objeto data
     * @param value Valores asociados a la nueva entrada
     */
    persis(name: string, value: any): void {
        let data: any = localStorage.getItem('data');
        if (data == null) {
            data = {};
        } else {
            data = JSON.parse(data);
        }
        data[name] = value;
        data = JSON.stringify(data);
        localStorage.setItem('data', data);
    }


    /**
     * Retorna el valor de una variable almacenada en el objeto "data" que se guarda en el localStorage
     * @param name Nombre de la variable que se quiere obtener el dato
     */
    getLocalItem(name: string): any {
        let data: any = localStorage.getItem('data');
        if (data == null) {
            return null;
        } else {
            data = JSON.parse(data);
            return data[name];
        }
    }


    /**
     * Elimina una variable guardada en el objeto data que se encuentra guardado en localStorage
     * @param nombre Nombre del elemento que se desea eliminar
     */
    deleteLocalItem(nombre: string): void {
        let data: any = localStorage.getItem('data');
        if (data != null) {
            data = JSON.parse(data);
            delete data[nombre];
            localStorage.setItem('data', JSON.stringify(data));
        }
    }


    /**
     * Deja un mensaje en localStorage
     * @param titulo Titulo del mensaje
     * @param msg Cuerpo del mensaje
     * @param tipo Tipo del mensaje, valores posibles: error, success, warning, info
     */
    public setMensaje(titulo: string, msg: string, tipo: string): void {
        this.persis('msg', { titulo: titulo, mensaje: msg, tipo: tipo });
    }


    /**
     * Busca en localStorage si existe algun mensaje
     * Valores retornados: false o {titulo, mensaje, tipo}
     */
    public getMensaje(): Object | boolean {
        let m: any = this.getLocalItem('msg');
        this.deleteLocalItem('msg');
        if (m) {
            return m;
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/app.core.ts